module.exports = __webpack_public_path__ + "img/cayman-islands.ec6d0c3f.svg";